import { Language } from '@/utils/language';
import { Author } from './Author';
import { Category } from './Category';
import { EditorialContent } from './EditorialContent';
import { Tag } from './Tag';

export type WrittenContent = {
  id: string;
  type: 'story' | 'article' | 'liveblogstory';
  headline: string;
  image?: any | object;
  lead?: string;
  body?: string | object;
  language: Language;
  slug: string;
  shorthandUrl?: string;
  authors?: Author[];
  categories?: Category[];
  tags?: Tag[];
  isBreaking?: boolean;
  hasTextToSpeech?: boolean;
  publishedAt: string;
  updatedAt: string;
};

export function isWrittenContent(content: EditorialContent): content is WrittenContent {
  return (
    (content.type === 'story' || content.type === 'article' || content.type === 'liveblogstory') &&
    typeof content.id === 'string'
  );
}